import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { AxiosRequestConfig } from 'axios';
import { IManagementUGO, IRealEstate, IUser } from './interfaces';

export const getManagementUGOList = (data: IDynamicTableParams) => {
  return instance()
    .post<IManagementUGO[]>('/managementUgo/list', data)
    .then((response) => response.data);
};

export const getManagementUGOListAll = () => {
  return instance()
    .post<IManagementUGO[]>('/managementUgo/listAll')
    .then((response) => response.data);
};

export const getManagementUGOListAllNotDeleted = () => {
  return instance()
    .get<IManagementUGO[]>('/managementUgo/listAllNotDeleted')
    .then((response) => response.data);
};

export const getManagementUGOAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/managementUgo/availableColumns')
    .then((response) => response.data);
};

export const getManagementUGOAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/managementUgo/availableGroupColumns')
    .then((response) => response.data);
};

export const loadManagementUGO = (managementUgoId: number) => {
  return instance()
    .get<IManagementUGO>(`/managementUgo/load/${managementUgoId}`)
    .then((response) => response.data);
};

export const createManagementUGO = (managementUgo: IManagementUGO) => {
  return instance()
    .post<IManagementUGO>(`/managementUgo/save`, managementUgo)
    .then((response) => response.data);
};

export const updateManagementUGO = (managementUgo: IManagementUGO) => {
  return instance()
    .post<IManagementUGO>(`/managementUgo/${managementUgo.managementUgoId}/update`, managementUgo)
    .then((response) => response.data);
};

export const archiveManagementUGO = (managementUgoId: number) => {
  return instance()
    .post(`/managementUgo/archive`, { managementUgoId })
    .then((response) => response.data);
};

export const recoverManagementUGO = (managementUgoId: number) => {
  return instance()
    .post(`/managementUgo/recover`, { managementUgoId })
    .then((response) => response.data);
};

export const getUsers = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IUser[]>('/users/listPerformance', { search: config?.params.search }, config)
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { includeUnserved?: boolean; includeDeleted?: boolean; searchWithCity?: boolean; nameWithCity?: boolean } = {
    includeUnserved: true,
    includeDeleted: true,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};
